/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ROUTES } from "../constants";
import { CellType, ComponentType, Orientation } from "../enums";
import { IListComponentModel } from "../models/Configuration";
import {
  IPlaylistScreenLinkOptions,
  IPlaylistScreenLocation,
  IPlaylistScreenLocationState,
  IResolvePlaylistListComponentOptions,
} from "../models/Screens/Playlist";

import { ConfigurationHelper } from "./configurationHelper";
import { UrlHelper } from "./url.helper";

export class PlaylistScreenHelper {
  static getLocation = (
    component: IListComponentModel,
    options?: IPlaylistScreenLinkOptions,
  ): IPlaylistScreenLocation | undefined => {
    if (!component.SourceId) {
      return undefined;
    }

    const basePath = `${ROUTES.PLAYLIST_SCREEN}/${component.SourceId}/${component.CellType}`;
    const pathname =
      options?.categoryId || !component.Title
        ? basePath
        : `${basePath}/${component.Title}`;

    const queryParams: Record<string, string> = {};

    if (component.Id !== undefined && component.Id !== null) {
      queryParams.componentId = `${component.Id}`;
    }

    if (options?.categoryId !== undefined && options?.categoryId !== null) {
      queryParams.category = `${options.categoryId}`;
    }

    const search = Object.keys(queryParams).length
      ? `?${UrlHelper.stringify(queryParams)}`
      : undefined;

    return {
      pathname,
      search,
      state: { component },
    };
  };

  static getListComponent = ({
    configuration,
    locationState,
    componentId,
    cellType,
    mediaList,
  }: IResolvePlaylistListComponentOptions): IListComponentModel => {
    const stateComponent = (
      locationState as IPlaylistScreenLocationState | undefined
    )?.component;
    const configurationComponent =
      componentId !== undefined && componentId !== null
        ? ConfigurationHelper.getComponentById<IListComponentModel>(
            configuration,
            componentId,
            ComponentType.List,
          )
        : undefined;
    const resolvedCellType = cellType || CellType.Frame;
    const baseComponent = stateComponent || configurationComponent;

    if (baseComponent) {
      return {
        ...baseComponent,
        ComponentTypeCode: ComponentType.List,
        CellType: baseComponent.CellType || resolvedCellType,
        Orientation: Orientation.Grid,
        MediaList: mediaList,
      };
    }

    return {
      ComponentTypeCode: ComponentType.List,
      CellType: resolvedCellType,
      Orientation: Orientation.Grid,
      MediaList: mediaList,
    };
  };
}
